/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Goals_HInputs */

const en_funnel_ob_goals_h = /** @type {(inputs: Funnel_Ob_Goals_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why do you want to use Listening?`)
};

const es_funnel_ob_goals_h = /** @type {(inputs: Funnel_Ob_Goals_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué quieres usar Listening?`)
};

/**
* | output |
* | --- |
* | "Why do you want to use Listening?" |
*
* @param {Funnel_Ob_Goals_HInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_goals_h = /** @type {((inputs?: Funnel_Ob_Goals_HInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Goals_HInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_goals_h(inputs)
	return en_funnel_ob_goals_h(inputs)
});